import { reactive, computed, onBeforeMount } from '@vue/composition-api'
import { formatDateKanji } from '@/util/common'
import { PRODUCT_STATUS, PRODUCT_STATUS_NAME } from '@/util/constants'

export const ServiceDetail = (context) => {

  onBeforeMount(() => {
    // 審査中状態のチェック
    store.dispatch('payment/checkAvailablePurchase')
  })

  const store = context.root.$store
  const { contractPack: { selectPackage }, contract } = store.state

  // const selectPackage = contractPack.selectPackage
  const isAgreement = computed(() => store.getters['contract/isAgreement'])
  const basicProduct = computed(() => store.getters['contractPack/basicProduct'])
  const optionProduct = computed(() => store.getters['contractPack/optionProduct'])
  const trialProduct = computed(() => store.getters['contractPack/trialProduct'])
  const isOldPackage = computed(() => store.getters['contractPack/isOldPackage'])
  const isCancelPackage = computed(() => store.getters['contractPack/isCancelPackage'])
  const isTrialPackage = computed(() => store.getters['contractPack/isTrialPackage'])
  const isUnSignedPackage = computed(() => store.getters['contractPack/isUnSignedPackage'])
  const clickCancelReserve = async (select) => {
    store
      .dispatch('contractPack/setSelectProduct', select)
      .then(() => {
        state.visibleCancelInput = true
      })

  }
  const state = reactive({
    visibleCancelInput: false,
    isUnderExam: computed(() => store.state.payment.isUnderExam), // 審査中フラグ
    boughtThisMonthDifPayment: computed(() => store.state.payment.boughtThisMonthDifPayment) // 同月異なる決済方法での購入済みフラグ
  })

  return {
    formatDateKanji,
    isAgreement,
    contract,
    selectPackage,
    basicProduct,
    optionProduct,
    trialProduct,
    isOldPackage,
    isCancelPackage,
    isTrialPackage,
    isUnSignedPackage,
    clickCancelReserve,
    state,
    PRODUCT_STATUS,
    PRODUCT_STATUS_NAME
  }
}
